/**
 * Platform-neutral seam for "make this deck's card bodies resident" OUTSIDE
 * React — for a write that must read every card of a deck and runs where no
 * hook can: the upload queue landing a document in the background
 * (`deck-sources.ts`, pinning the outgoing primary's cards before index 0
 * moves).
 *
 * The rehydrate itself is provider-bound (`useColdDeckActions` needs the live
 * UserDo socket), so the sync core registers it here once it has one
 * (`provider/deck-cards-hydrator-registrar.ts`) and clears it when the
 * connection goes away. `null` means "no way to reach the server right now":
 * the caller decides what a write it cannot make safe does instead.
 */

export type DeckCardsHydrator = (deckId: string) => Promise<void>;

let hydrator: DeckCardsHydrator | null = null;

export function setDeckCardsHydrator(fn: DeckCardsHydrator | null): void {
  hydrator = fn;
}

export function getDeckCardsHydrator(): DeckCardsHydrator | null {
  return hydrator;
}
